<template>
<div class="user_tab1 no-trans" v-loading="loading">


    <div class="box3_top">
        <div class="borders"></div>
        <div class="texts">奖励获得记录</div>
    </div>
    <div class="box3_bom">
        <div class="order_list">
            <el-table :data="order_list" style="width: 100%">          
                <el-table-column prop="order_sn" label="奖励单号"></el-table-column>
                <el-table-column prop="title" label="产品名称"> </el-table-column>
                <el-table-column prop="created_at" label="获得时间"> </el-table-column>
                <el-table-column prop="yongjin" label="奖励"> </el-table-column>
                
            </el-table>


        </div>
        
        <div class="pages_box">
            <div class="btns" @click="handle_pages(1)">首页</div>
            <site-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pages.page" background :page-size="pages.limit" layout="prev, pager, next"
                :total="total">
            </site-pagination>
            <div class="btns" @click="handle_pages(10)">尾页</div>
        </div>
    </div>



</div>
</template>
<script>
import { mapState } from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,


            order_list: [],

            total: 100,
            pages: {
                page: 1,
                limit: 10,
            },

        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
         get_list(){
            this.loading=true
            this.$api("yongjingLog", {
                ...this.pages,
                type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('我的奖励列表',res)
                if (res.code == 1) {
                    this.order_list=res.data.list
                    this.total=res.data.count
                } else {
                    alertErr(res.msg)
                }
            });
        },

        handleSizeChange(e) {
            console.log('条数', e)
        },
        handleCurrentChange(e) {
            console.log('页数', e)
        },
        handle_pages(i) {
            console.log('首页尾页', i)
            this.pages.page = i
        },
        handle_deitial() {
            this.$router.push({
                path: '/user_wt/user_wt_detial',
                query: {

                }
            })
        },
        handle_yq() {
            this.$refs.user_jf_pop.handle_open()
        },
        




    },

}
</script>
<style scoped lang="less">
.user_tab1 {

    background-color: #FFFFFF;
    margin-top: 17px;

    .box3_top {
        display: flex;
        align-items: center;
        height: 56px;
        border-bottom: 1px solid #DEDEDE;

        .borders {
            width: 4px;
            height: 22px;
            background: #377CFD;
            border-radius: 3px 3px 3px 3px;
        }

        .texts {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 18px;
            color: #333333;
            padding-left: 28px;
        }
    }

    .box3_bom {
        padding: 24px 32px;

        .order_list {
            border: 1px solid #E5E5E5;
            /deep/.el-table{
                .el-table__header-wrapper{
                    .el-table__cell{
                        background-color: hsla(219, 98%, 60%, 0.03);
                        text-align: left !important;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        padding: 0 !important;
                        height: 44px;
                    }
                    .el-table__cell:nth-child(1){
                        padding-left: 24px !important;
                    }
                }
                .el-table__body-wrapper{
                    .el-table__row{
                        .el-table__cell{
                            text-align: left !important;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #333333;
                        }
                        .el-table__cell:nth-child(1){
                        padding-left: 24px !important;
                    }
                    }
                }
            }

           

        }
    }


    .pages_box {
        width: 100%;
        height: 100px;
        // background-color: red;
        display: flex;
        align-items: center;
        justify-content: end;

        /deep/.el-pagination {
            .btn-prev {
                background-color: #FFFFFF;
                border: 1px solid #EEEEEE;

            }

            .el-pager {
                .number {
                    background-color: #FFFFFF;
                    border: 1px solid #EEEEEE;

                }

                .active {
                    background-color: #377CFD;
                }

                .el-icon {
                    background-color: #FFFFFF;
                }
            }

            .btn-next {
                background-color: #FFFFFF;
                border: 1px solid #EEEEEE;

            }
        }

        .btns {
            width: 40px;
            height: 32px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #EEEEEE;
            font-family: PingFang-SC-Medium, PingFang-SC-Medium;
            font-weight: normal;
            font-size: 14px;
            color: #7A7A7A;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_tab1.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        margin-top: 16px;
    }
    .user_tab1.no-trans .box3_top {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        height: auto;
        min-height: 44px;
    }
    .user_tab1.no-trans .box3_top .borders {
        width: 4px;
        height: 22px;
        border-radius: 3px 3px 3px 3px;
    }
    .user_tab1.no-trans .box3_top .texts {
        font-size: 18px;
        padding-left: 16px;
    }
    .user_tab1.no-trans .box3_bom {
        padding: 16px 16px;
    }
    .user_tab1.no-trans .box3_bom .order_list /deep/ .el-table .el-table__header-wrapper .el-table__cell {
        font-size: 14px;
        padding: 0 !important;
        height: 44px;
    }
    .user_tab1.no-trans .box3_bom .order_list /deep/ .el-table .el-table__header-wrapper .el-table__cell:nth-child(1) {
        padding-left: 16px !important;
    }
    .user_tab1.no-trans .box3_bom .order_list /deep/ .el-table .el-table__body-wrapper .el-table__row .el-table__cell {
        font-size: 16px;
    }
    .user_tab1.no-trans .box3_bom .order_list /deep/ .el-table .el-table__body-wrapper .el-table__row .el-table__cell:nth-child(1) {
        padding-left: 16px !important;
    }
    .user_tab1.no-trans .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_tab1.no-trans .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
